<template>
  <div class="LmAvatar flex-shrink-0">
    <img
      v-if="src"
      class="Avatar border border-gray-200"
      :src="src"
      :alt="alt"
      :width="size"
      :height="size"
    />
    <div v-else class="Placeholder Avatar" :style="{width: size, height: size}">
      <lm-material-icon icon="person" :style="{'font-size': `${fontSize}`}" />
    </div>
  </div>
</template>

<script>
import LmMaterialIcon from '@/components/ui/LmMaterialIcon'
export default {
  name: 'LmAvatar',
  components: {LmMaterialIcon},
  props: {
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: '40px'
    }
  },
  computed: {
    fontSize() {
      // TODO: switch
      return this.size === '40px' ? '24px' : '19px'
    }
  }
}
</script>

<style scoped>
.LmAvatar {
  line-height: 0;
  .Avatar,
  .Placeholder {
    border-radius: 100px;
  }
  .Placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #999;
    i {
      color: #999;
    }
  }
}
</style>
